import React from "react";
import {
    ButtonIconCopyClipboard,
    ButtonIconEdit,
    SelectField,
} from "../../../../Components/Inputs";
import {HtmlDisplay} from "../../../../Components/Display";
import {LOAN_LIBRARY_LOAN_STATUS_LIST} from "./loanLibraryLoanConstants";
import {truncateString} from "../../../../Utilities/commonUtilities";
import {ButtonIconPackingList} from "../../../../Components/Inputs/Buttons/ButtonIcon/ButtonIcon";
import {LoanLibraryLoanItem} from "./loanLibraryLoan.types";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface LoanLibraryLoanRowProps {
    loanLibraryLoanItem: LoanLibraryLoanItem;
    canManageLoanLibraryLoans: boolean;
    handleCopyToClipboard: () => void;
    handleOpenEditDialog: (event: React.MouseEvent<HTMLElement>, item: LoanLibraryLoanItem) => void;
    handlePacking: () => void;
    handleReturnLoan?: (loanId: string) => void;
    handleUpdateLoanStatus: (loanId: string, status: string | number) => void;
}

export const LoanLibraryLoanRow = ({
    loanLibraryLoanItem,
    canManageLoanLibraryLoans,
    handleCopyToClipboard,
    handleOpenEditDialog,
    handlePacking,
    handleUpdateLoanStatus,
}: LoanLibraryLoanRowProps) => {

    const handleLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        handleUpdateLoanStatus(loanLibraryLoanItem.loanLibraryLoanId, event.target.value);
    };

    return (
        <tr id={loanLibraryLoanItem.loanLibraryLoanId}>
            <td>
                {loanLibraryLoanItem.inventoryShortId}
            </td>
            <td>
                {loanLibraryLoanItem.checkedOutDateFormatted}
            </td>
            <td>
                {loanLibraryLoanItem.dueDateFormatted}
            </td>
            <td>
                {loanLibraryLoanItem.dateSubmitted}
            </td>
            <td>
                {loanLibraryLoanItem.catalogItemTitle}
            </td>

            <td>
                {loanLibraryLoanItem.patronFullName}
            </td>
            <td>
                {loanLibraryLoanItem.shelfLocation}
            </td>
            <td>
                {loanLibraryLoanItem.shippingLocationName}
            </td>
            <td>
                {
                    canManageLoanLibraryLoans ?
                        <SelectField
                            hideLabel
                            includeDefaultOption={false}
                            label={`Loan Library Loan Status for ${loanLibraryLoanItem.catalogItemTitle}`}
                            name={`loan-library-loan-status-${loanLibraryLoanItem.loanLibraryLoanId}`}
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleLoanStatusChange(event)}
                            options={LOAN_LIBRARY_LOAN_STATUS_LIST}
                            value={loanLibraryLoanItem.loanLibraryLoanStatus}
                        />
                        :
                        <HtmlDisplay
                            html={LOAN_LIBRARY_LOAN_STATUS_LIST.find((f: ListItem) => f.value === loanLibraryLoanItem.loanLibraryLoanStatus)?.text || `Unknown Status (${loanLibraryLoanItem.loanLibraryLoanStatus})`}
                            name={`loan-library-loan-status-${loanLibraryLoanItem.loanLibraryLoanId}`}
                        />
                }
            </td>
            <td>
                {truncateString(loanLibraryLoanItem.loanLibraryLoanNotes)}
            </td>
            <td className={`align-center`}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', gap: '5px'}}>
                    {
                        canManageLoanLibraryLoans &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px'}}>
                            <ButtonIconEdit
                                inputDescription={`for ${loanLibraryLoanItem.catalogItemTitle}`}
                                onClick={(event) => event && handleOpenEditDialog(event, loanLibraryLoanItem)}
                            />
                        </div>
                    }
                    <ButtonIconCopyClipboard
                        inputDescription={`for ${loanLibraryLoanItem.catalogItemTitle}`}
                        onClick={handleCopyToClipboard}
                    />

                    <ButtonIconPackingList
                        inputDescription={`for ${loanLibraryLoanItem.catalogItemTitle}`}
                        onClick={handlePacking}
                    />
                </div>
            </td>
        </tr>
    );
};

